<div class="row myfit content-margin">
  @switch(ticketPaymentStatus) {
    @case(StudentTicketPaymentStatus.EXTERNAL) {
      <div class="col ">
        <div class="payment-status row-item" data-cy="ticket-payment-details-card-status-external"
             [ngStyle]="{color: getTicketPaymentStatusColor(ticketPaymentStatus)}">
          <span class="icon-container">
            <fa-icon [icon]="faCreditCard"></fa-icon>
          </span>
          <span>
            {{'TICKETS.PAYMENT_STATUS.' + ticketPaymentStatus |translate}}
          </span>
        </div>
        <div class="card-title row-item"data-cy="ticket-payment-details-card-name">
          <span class="icon-container">
            <fa-icon [icon]="faPerson"></fa-icon>
          </span>
          <span>
          {{ticketMandateInformation?.mandateHolderFirstname}}
          {{ticketMandateInformation?.mandateHolderLastname}}
          </span>
        </div>
        <div class="row-item" data-cy="ticket-payment-details-card-address">
          <div class="address-flex-container">
            <div class="icon-container">
              <fa-icon [icon]="faLocationDot"></fa-icon>
            </div>
            <div class="address-lines">
              @for(line of mandateHolderAddress; track $index){
                <div>
                  {{line}}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <!-- Data changes are only editable via the verification wizard now; individual edit options disabled.
        <div class="button-container mb-3">
          <div class="btn-group" ngbDropdown>
            <button type="button"
                    class="btn btn-outline-primary dropdown-toggle"
                    ngbDropdownToggle
                    data-cy="ticket-payment-details-dropdown-button">
              <fa-icon [icon]="faPenToSquare"></fa-icon>
              <span class="visually-hidden">{{ 'TICKETS.BUTTON_EDIT_PAYMENT_SECTION' | translate }}</span>
            </button>
            <ul class="dropdown-menu" ngbDropdownMenu>
              <li>
                <button class="dropdown-item"
                        data-cy="ticket-payment-details-change-data-button"
                        (click)="triggerChangeMandateHolderInfo()">
                  <span>{{ 'TICKETS.BUTTON_CHANGE_PAYMENT_DATA' | translate }}</span>
                </button>
              </li>
              @if (geschwisterEigenanteilKomponenteEnabled) {
                <li>
                  <button class="dropdown-item"
                          data-cy="ticket-payment-details-adjust-geschwister-button"
                          (click)="triggerGeschwisterAdjust()">
                    <span>{{ 'TICKETS.BUTTON_ADJUST_GESCHWISTER' | translate }}</span>
                  </button>
                </li>
              }
            </ul>
          </div>
        </div>
        -->
        <div class="row-item" data-cy="ticket-payment-details-card-iban">
          <span class="icon-container">
            <fa-icon  [icon]="faCreditCard"></fa-icon>
          </span>
          <span>
          {{ticketMandateInformation?.mandateHolderIban}}
          </span>
        </div>
        <div class="row-item" data-cy="ticket-payment-details-card-bic">
          <span class="icon-container">
            <fa-icon  [icon]="faLandmark"></fa-icon>
          </span>
          <span>
          {{ticketMandateInformation?.mandateHolderBic}}
          {{ticketMandateInformation?.mandateHolderBankName}}
          </span>
        </div>
        <div class="payment-amount row-item mt-2">
          <span class="icon-container">
          <fa-icon [icon]="faCoins"></fa-icon>
          </span>
          <span>
           @if(ticketPaymentInfo?.payableAmount) {
             {{ 'TICKETS.PAYABLE_AMOUNT' | translate }}:
           }
            <span data-cy="ticket-payment-details-card-payable-amount"> {{ ticketPaymentInfo?.payableAmount | currency:'EUR':'symbol-narrow':'1.2-2'}} </span>
          </span>
        </div>
      </div>
    }
    @case(StudentTicketPaymentStatus.PENDING) {
      <div class="col ">
        <div class="payment-status row-item" data-cy="ticket-payment-details-card-status-pending"
             [ngStyle]="{color:  getTicketPaymentStatusColor(ticketPaymentStatus)}">
          <span class="icon-container">
            <fa-icon  [icon]="faCreditCard"></fa-icon>
          </span>
          <span>
            {{ 'TICKETS.PAYMENT_STATUS.' + ticketPaymentStatus |translate }}
          </span>
        </div>
        <div class="payment-amount row-item">
          <span class="icon-container">
            <fa-icon [icon]="faCoins"></fa-icon>
          </span>
          <span>
             @if(ticketPaymentInfo?.payableAmount) {
               {{ 'TICKETS.PAYABLE_AMOUNT' | translate }}:
             }
            <span data-cy="ticket-payment-details-card-payable-amount"> {{ ticketPaymentInfo?.payableAmount | currency:'EUR':'symbol-narrow':'1.2-2'}} </span>
          </span>
        </div>
      </div>
    }
    @case(StudentTicketPaymentStatus.PAID  || StudentTicketPaymentStatus.OVERPAID || StudentTicketPaymentStatus.UNDERPAID) {
      <div class="col ">
        <div class="payment-status row-item"
             [ngStyle]="{color:  getTicketPaymentStatusColor(ticketPaymentStatus)}">
          <span class="icon-container">
            <fa-icon  [icon]="faCreditCard"></fa-icon>
          </span>
          {{ 'TICKETS.PAYMENT_STATUS.' + ticketPaymentStatus |translate }}
        </div>
        <div class="payment-amount row-item">
          <span class="icon-container">
            <fa-icon  [icon]="faCoins"></fa-icon>
          </span>
          @if(ticketPaymentInfo?.payableAmount) {
            {{ 'TICKETS.PAYABLE_AMOUNT' | translate }}:
          }
          <span data-cy="ticket-payment-details-card-payable-amount"> {{ ticketPaymentInfo?.payableAmount | currency:'EUR':'symbol-narrow':'1.2-2'}} </span>
        </div>
      </div>
    }
    @default {
      <div class="col ">
        <div class="payment-status payment-no row-item">
          <span class="icon-container">
          <fa-icon  [icon]="faCreditCard"></fa-icon>
          </span>
          {{ 'TICKETS.PAYMENT.NONE'|translate }}
        </div>
      </div>
    }
  }
</div>
